import { render, staticRenderFns } from "./MidwifeNewActivity.vue?vue&type=template&id=7f03f42a"
import script from "./MidwifeNewActivity.vue?vue&type=script&lang=js"
export * from "./MidwifeNewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports